import styled from "styled-components";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { ITheme } from "@swiggy-private/dls-web-common/dist/components/types";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";

export const Footer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.empty,
    display: "flex",
    alignItems: "center",
}));

export const FooterFirst = styled.button(({ theme }) => ({
    width: "40%",
    background: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    borderRadius: `${getCornerRadius(theme, "xxSmall")} 0 0 ${getCornerRadius(theme, "xxSmall")}`,
    outline: "none",
}));

export const ViewBillText = styled(Text)(({ theme }) => ({
    marginToop: theme.spacing.xxxSmall,
}));

const baseButtonStyles = ({
    theme,
    isPopCart,
    isQuickCheckoutCartFlow = false,
}: {
    theme: ITheme;
    isPopCart?: boolean;
    isQuickCheckoutCartFlow?: boolean;
}) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "60%",
    height: "52px",
    background: theme.colors[theme.colorMode].special_positive,
    border: "1px solid transparent",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.12)",
    borderRadius: getCornerRadius(theme, "small"),
    outline: "none",
    "&:disabled": {
        opacity: 0.8,
    },

    ...(isPopCart && {
        background: "#CAFE33",
        border: `1px solid ${theme.colors[theme.colorMode].text_Highest_Emphasis}`,
    }),
    ...(isQuickCheckoutCartFlow && {
        width: "100%",
        background: theme.colors[theme.colorMode].positive,
    }),
});

export const MakePaymentButton = styled.div<{ isPopCart?: boolean; isQuickCheckoutCartFlow?: boolean }>(
    baseButtonStyles,
);

export const SelectDeliverySlotButton = styled.button<{ isPopCart?: boolean }>(baseButtonStyles);

export const FullWidthPayButton = styled(FullWidthButton)(({ theme }) => ({
    background: theme.colors[theme.colorMode].positive,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "52px",
    borderRadius: theme.cornerRadius.small,
}));

export const Title = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.xxxSmall,
}));

export const Subtitle = styled.div({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
});
